import { ActionTree } from "vuex";
import { ILevelState } from "./levels-types";
import { generateBaseActionsFor } from "../utils/base-generators";
import { RootState } from "../root-state";
import { ILevel } from "@/services/data/level/level.interface";
import { levelProvider } from "@/services/data/level/level.provider";

export const actions: ActionTree<ILevelState, RootState> =
  generateBaseActionsFor<ILevelState, ILevel>("levels", levelProvider);
